import React, { useState } from "react";

import { CircularProgress } from "@material-ui/core";

import { Button, RefreshButton, useRefresh } from "react-admin";

import { ExternalStatus } from "../../utils/constants";
import { ImportExportFailedIcon } from "./iconography";

export const ReSyncButton = ({ record, isSyncEnabled, syncFn, ...props }) => {
  const refresh = useRefresh();
  const [loading, setLoading] = useState(false);

  const handleResync = async () => {
    setLoading(true);
    await syncFn(record);
    setLoading(false);
    refresh();
  };

  if (!isSyncEnabled || record?.externalStatus === ExternalStatus.SYNCED)
    return null;
  if (isSyncEnabled && record?.externalStatus === ExternalStatus.SYNC_PENDING)
    return <RefreshButton {...props} />;
  return (
    <Button label="Sync" onClick={handleResync} disabled={loading}>
      {loading ? (
        <CircularProgress color="inherit" size={17} />
      ) : (
        <ImportExportFailedIcon />
      )}
    </Button>
  );
};
